import React from 'react'
import { Head } from '../../component'
import { CardEducation } from './components'
import { Route } from '../../config/router'
import { TrackPageViewed } from '../../integrations/monitoring'
import { CheckoutPage } from '../../model'
import { useAppRouter } from '../../state'
import { useTranslation } from '../../utils/convergence'

export const CardEducationPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const pageTitle = t('common:brandName')

  const handleContinue = (): void => {
    router.replaceQuery({ pathname: Route.APPLE_PAYLATER_INITIALISE, query: router.query })
  }

  return (
    <>
      <Head title={pageTitle} />
      <CardEducation onContinue={handleContinue} />
      <TrackPageViewed />
    </>
  )
}
